<template>
  <div class="organ-group-dialog">
    <custom-dialog width="75%" :title="model.title" :visible="visible" v-on="$listeners">
      <custom-tab v-model="currentTab" :list="tabs"></custom-tab>
      <div class="dialog-body" style="padding-top: 0" v-show="currentTab == 'tab1'">
        <div class="ubv">
          <div class="search-hd">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item>
                <p style="color: #0d9ae0; font-size: 13px">{{ $t('base_organGroupDialog.rxzlzzdwxzkxzzzdsysb') }}</p>
              </el-form-item>
              <el-form-item style="float: right; margin-right: 0">
                <search-input :placeholder="$t('base_organGroupDialog.zzbmmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="table-bd">
            <custom-table
              ref="customTb1"
              :index="true"
              type="checkbox"
              tableCode="organ_group"
              v-model="tableSelect"
              :data="dataList"
              @column="setColumn"
              @filter="filterChange"
              @sort="sortChange"
              :slots="['autoDeptList', 'action']"
            >
              <template slot="autoDeptList" slot-scope="scope">
                <el-tag v-for="tag in scope.row.autoDeptList" :key="tag.bizId" closable @close="handleClose(scope.row, tag)">
                  {{ tag.bizName }}
                </el-tag>
              </template>
              <template slot="action" slot-scope="scope">
                <el-button type="text" size="mini" @click="openBindGroup(scope.row, scope.$index)">{{ $t('base_organGroupDialog.xuan_ze_bu_men') }}</el-button>
              </template>
            </custom-table>
          </div>
          <div class="table-page">
            <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
          </div>
        </div>
      </div>
      <div class="dialog-body" style="padding-top: 0" v-show="currentTab == 'tab2'">
        <div class="ubv">
          <div class="search-hd">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item style="float: right; margin-right: 0">
                <search-input :placeholder="$t('base_organGroupDialog.gong_si_ming_cheng')" v-model="formSearch2.orgName" @fetch="onPageChange2({ page: 1 })"></search-input>
              </el-form-item>
              <el-form-item style="float: right; margin-right: 12px">
                <el-input :placeholder="$t('base_organGroupDialog.xiang_mu_ming_cheng')" style="width: 200px" v-model="formSearch2.locationName" @change="onPageChange2({ page: 1 })"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="table-bd">
            <custom-table ref="customTb2" :index="true" type="checkbox" tableCode="organ_group_location" v-model="tableSelect2" :data="dataList2"></custom-table>
          </div>
          <div class="table-page">
            <custom-page :total="totalRows2" :page="formSearch2.pageNum" :size="formSearch2.pageSize" @change="onPageChange2"></custom-page>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveOrganGroup" :disabled="!tableSelect.length && !tableSelect2.length">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
    <organ-group-tree-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSelectGroup"></organ-group-tree-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import organGroupTreeDialog from '@/pages/base/components/organGroupTreeDialog';

export default {
  mixins: [dialogMixins],
  components: { organGroupTreeDialog },
  props: {
    orgId: [String, Number],
  },
  data() {
    return {
      currentTab: 'tab1',
      formSearch: {
        orgId: this.orgId,
        userId: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 10,
        pageNum: 1,
      },
      formSearch2: {
        orgId: this.orgId,
        userId: '',
        search: '',
        orgName: '',
        locationName: '',
        orderBy: '',
        orderType: '',
        pageSize: 10,
        pageNum: 1,
      },
      dataList: [],
      totalRows: 0,
      tableSelect: [],
      dataList2: [],
      totalRows2: 0,
      tableSelect2: [],
      dialogVisible: false,
      dialogModel: {},
    };
  },
  computed: {
    tabs() {
      return [
        {
          name: this.$t('base_organGroupDialog.zu_zhi_bu_men'),
          value: 'tab1',
          code: 'tab1',
        },
        {
          name: this.$t('base_organGroupDialog.xiang_mu'),
          value: 'tab2',
          code: 'tab2',
        },
      ];
    },
  },
  mounted() {
    this.formSearch.userId = this.model.userId;
    this.formSearch2.userId = this.model.userId;
    this.getOrganGroup();
    this.getLocationList();
  },
  methods: {
    // 获取子公司列表
    getOrganGroup: function () {
      this.$getJSON(apis.organChildrenBizPage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.toBizType = 1;
          item.bizId = item.orgId;
          item.autoDeptList = [];
        });
        this.dataList = list;
        this.totalRows = res.data.total;
      });
    },
    // 分页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getOrganGroup();
    },
    // 获取项目列表
    getLocationList: function () {
      this.$getJSON(apis.deviceOrganLocation, this.formSearch2).then((res) => {
        const list = res.data.list || [];
        this.dataList2 = list;
        this.totalRows2 = res.data.total;
      });
    },
    // 项目分页
    onPageChange2: function ({ page, size }) {
      this.formSearch2.pageNum = page;
      this.formSearch2.pageSize = size || this.formSearch2.pageSize;
      this.getLocationList();
    },
    // 确认提交
    saveOrganGroup: function () {
      const paramOrgs = this.tableSelect.filter((t) => t.autoDeptList.length === 0); // 组织
      const paramGroups = this.tableSelect.map((t) => t.autoDeptList).reduce((pre, item) => [...pre, ...item], []); // 部门
      let params = [...paramGroups, ...paramOrgs].map((t) => ({
        bizId: this.model.userId,
        bizType: 3,
        toBizId: t.bizId,
        toBizType: t.toBizType,
        orgId: t.orgId,
      }));
      // 添加选择的项目
      if (this.tableSelect2.length) {
        const locations = this.tableSelect2.map((t) => ({
          bizId: this.model.userId,
          bizType: 3,
          toBizId: t.locationId, // 项目取locationId
          toBizType: 4, // 项目取值4
          orgId: t.orgId,
        }));
        params = [...params, ...locations];
      }
      this.$postJSON(apis.organDeviceBindAutoAdd, params).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 删除部门
    handleClose(row, tag) {
      row.autoDeptList = row.autoDeptList.filter((t) => t.bizId !== tag.bizId);
    },
    // 新增部门
    openBindGroup: function (row, idx) {
      this.dialogModel.title = this.$t('base_organGroupDialog.xuan_ze_bu_men');
      this.dialogModel.orgId = row.orgId;
      this.dialogModel.index = idx;
      this.dialogModel.defaultCheckedKeys = row.autoDeptList.map((f) => f.bizId);
      this.dialogVisible = true;
    },
    // 选择部门
    onSelectGroup(orgId, rows) {
      const tableRow = this.dataList[this.dialogModel.index];
      if (tableRow) {
        tableRow.autoDeptList = rows || [];
      }
    },
  },
};
</script>

<style lang="scss">
.organ-group-dialog {
  .el-tag + .el-tag {
    margin-left: 10px;
  }
}
</style>
